package com.wintermar.inspection.feature.presentation.template.widget.preview

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_arrow_down
import inspection.composeapp.generated.resources.ic_arrow_up
import org.jetbrains.compose.resources.painterResource

@Composable
fun SectionRow(
    title: String,
    isExpanded: Boolean,
    modifier: Modifier = Modifier,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    color: ThemeColor = LocalAppTheme.current.color,
    onClick: () -> Unit
) {
    Column(
        modifier = modifier
            .fillMaxWidth()
            .background(color.surface.neutral.subtle.default)
    ) {
        HorizontalDivider(
            modifier = Modifier.fillMaxWidth(),
            color = color.border.default
        )
        Row(
            modifier = modifier
                .fillMaxWidth()
                .clickable {
                    onClick()
                }.padding(
                    vertical = dimension.spacing.space3,
                    horizontal = dimension.spacing.space2
                ),
            verticalAlignment = Alignment.Top,
            horizontalArrangement = Arrangement.spacedBy(dimension.spacing.space2)
        ) {
            Icon(
                painter = painterResource(if (isExpanded) Res.drawable.ic_arrow_up else Res.drawable.ic_arrow_down),
                tint = color.icon.subtle,
                contentDescription = title
            )
            TextBodySmall(title)
        }
    }
}
